import { ApiHelper, axiosInstance } from "../utils/ApiHelper"
import AnalyticsHelper from "../utils/AnalyticsHelper"
import CloudEvent from "../utils/CloudEvent"
import moment from "moment"
import axios from "axios"
import { SubmissionError, change } from "redux-form"
import { calculateRoute } from "../map/actions"
import { push, goBack } from "react-router-redux"
import { getTripById } from "./reducer"
import { message } from "antd"
import { isMatchingFilters, isNotMatchingFilters, isSameDate } from "../models"

export function renamePlace(data) {
  console.log({ data })
  return (dispatch, getState) => {
    dispatch({
      type: "SHOW_MODAL",
      modalType: "NAME_THIS_PLACE_MODAL",
      modalProps: {
        buttonText: "Update",
        title: `Rename this place`,
        message: `Update this existing favorite place:`,
        ...data
      }
    })
  }
}

export function addPlace(data) {
  console.log({ data })
  return (dispatch, getState) => {
    dispatch({
      type: "SHOW_MODAL",
      modalType: "NAME_THIS_PLACE_MODAL",
      modalProps: {
        buttonText: "Create",
        title: `Name this place`,
        message: `Set this reoccurring address as a favorite place:`,
        ...data
      }
    })
  }
}

export function toggleView() {
  return (dispatch, getState) => {
    dispatch({ type: "TOGGLE_VIEW" })
  }
}

export function getTrip(tripId) {
  return (dispatch, getState) => {
    dispatch({ type: "GET_TRIP_REQUEST" })
    // first look up in state
    const trip = getState().models.trips.find(trip => trip.token_id == tripId)
    if (trip) {
      dispatch({ type: "GET_TRIP_SUCCESS", trip })
      if (trip.calculate_route_enabled) {
        dispatch(change("trip", "calculate_route_enabled", true))
        // dispatch(calculateRoute())
      }
      // wrap in a promise that is expected to be returned
      const tripFromState = new Promise((resolve, reject) => {
        resolve(trip)
      })
      return tripFromState
    }
    // otherwise, request from backend
    return ApiHelper.getTrip(tripId).then(json => {
      const trip = json.data
      if (!trip.token_id) return dispatch({ type: "REJECT_TRIP_DETAIL" })
      dispatch({ type: "GET_TRIP_SUCCESS", trip })
      if (trip.calculate_route_enabled) {
        dispatch(change("trip", "calculate_route_enabled", true))
        // dispatch(calculateRoute())
      }

      return trip
    })
  }
}

export function getTrips() {
  return (dispatch, getState) => {
    const { filters } = getState().trips

    dispatch({ type: "GET_TRIPS_REQUEST", filters })

    return ApiHelper.getTrips(filters).then(json => {
      dispatch({ type: "GET_TRIPS_SUCCESS", user: { trips: json.data } })
      dispatch(toggleManyTrips())
    })
  }
}

export function mergeTrips(data) {
  return (dispatch, getState) => {
    const prevState = getState()

    dispatch({ type: "MERGE_TRIPS_REQUEST" })

    return ApiHelper.mergeTrips({ merge_trips_token_ids: data }).then(
      json => {
        AnalyticsHelper.trackEvent(CloudEvent.BatchMerged)
        dispatch({
          type: "MERGE_TRIPS_SUCCESS",
          merged_trip: json.data,
          token_ids: data
        })
        dispatch(decrementUnclassfiedCount(prevState, data))
      },
      error => {
        dispatch({ type: "MERGE_TRIPS_ERROR" })
      }
    )
  }
}

export function undoMerge(tripId) {
  return dispatch => {
    dispatch({ type: "UNDO_MERGE_TRIPS_REQUEST", tripId })

    return ApiHelper.undoTripMerge(tripId).then(
      json => {
        dispatch({
          type: "UNDO_MERGE_TRIPS_SUCCESS",
          payload: json.data,
          mergedTripId: tripId
        })
      },
      error => {
        dispatch({ type: "UNDO_MERGE_TRIPS_ERROR" })
      }
    )
  }
}

export function deleteTrip(tripId) {
  return dispatch => {
    return dispatch(deleteTrips({ token_ids: [tripId] }))
  }
}

export function deleteTrips(data) {
  return (dispatch, getState) => {
    const prevState = getState()
    dispatch({ type: "DELETE_TRIPS_REQUEST", data: data })

    return ApiHelper.deleteTrips({ filter_params: data }).then(
      json => {
        dispatch(getTotals())
        AnalyticsHelper.trackEvent(CloudEvent.TripDeleted)
        dispatch({ type: "DELETE_TRIPS_SUCCESS", token_ids: data.token_ids })
        dispatch(decrementUnclassfiedCount(prevState, data.token_ids))

        dispatch(untoggleAllTrips())
      },
      error => {
        dispatch({ type: "DELETE_TRIPS_ERROR" })
      }
    )
  }
}

export function onDateChange(date) {
  return (dispatch, getState) => {
    if (date && date.isValid())
      dispatch(change("trip", "date", moment(date).format("MMM DD, YYYY")))
    if (date && !date.isValid()) console.log("Date is invalid format")
  }
}

export function onSelectPurpose(purpose) {
  return (dispatch, getState) => {
    if (getState().models.user.income_sources.includes(purpose)) {
      dispatch(change("trip", "income_source", purpose))
      dispatch(change("trip", "purpose", "Work"))
    } else {
      dispatch(change("trip", "purpose", purpose))
      dispatch(change("trip", "income_source", null))
    }
  }
}

export function decrementUnclassfiedCount(prevState, ids) {
  return dispatch => {
    const count = ids.filter(id => getTripById(prevState, id).purpose == null)
      .length

    if (count > 0)
      dispatch({ type: "DECREMENT_UNCLASSIFIED_TRIP_COUNT", count })
  }
}

export function updateTrip(data) {
  return (dispatch, getState) => {
    const { purpose } = data
    const prevState = getState()
    const { income_sources } = getState().models.user
    const { filters } = getState().trips

    // If an income source was selected as purpose, then reshape data
    if (purpose && income_sources.includes(purpose)) {
      data["income_source"] = purpose
      data["purpose"] = "Work"
      // } else {
      //   data['income_source'] = ''//null
      //   data['purpose'] = purpose
      // }
    } else if (purpose && !data.income_source) {
      data["income_source"] = null
    }

    dispatch({
      type: "UPDATE_TRIP_REQUEST",
      trip: data,
      overrideSuccess: data.overrideSuccess
    })

    return ApiHelper.updateTrip(data).then(
      json => {
        const trip = json.data
        const noteUpdatedOnly = data.overrideSuccess
        if (!noteUpdatedOnly) dispatch(getTotals())
        AnalyticsHelper.trackEvent(CloudEvent.TripUpdated)
        dispatch({ type: "UPDATE_TRIP_SUCCESS", trip })
        dispatch(decrementUnclassfiedCount(prevState, [trip.token_id]))

        if (!noteUpdatedOnly) message.success(`Trip update success!`)

        if (isNotMatchingFilters(filters, trip))
          dispatch({ type: "REMOVE_TRIP", trip })
        // if (!isWithinDates(filters, trip)) alert('not within dates')

        return trip
      },
      err => {
        dispatch({ type: "UPDATE_TRIP_ERROR" })
      }
    )
  }
}

export const getUpdateParams = (state, purpose) => {
  const { income_sources } = state.models.user

  if (purpose && income_sources.includes(purpose)) {
    return {
      income_source: purpose,
      purpose: "Work"
    }
  } else {
    return {
      income_source: null,
      purpose
    }
  }
}

const withoutNulls = obj => {
  const newObj = { ...obj }
  Object.keys(newObj).forEach(key => newObj[key] == null && delete newObj[key])
  return newObj
}

export function batchClassify(purposeOption) {
  return (dispatch, getState) => {
    const prevState = getState()

    const {
      filter_params,
      filters,
      hasSelectedAll,
      totalResultsCount
    } = getState().trips

    const data = {
      filter_params: hasSelectedAll
        ? withoutNulls(filters) // NOTE we are removing null values
        : filter_params, // always array of token_ids
      update_params: getUpdateParams(getState(), purposeOption) // keep null values
    }

    dispatch({ type: "UPDATE_TRIP_BATCH_REQUEST", data })

    return ApiHelper.updateTrips(data).then(
      ({ data: trips }) => {
        AnalyticsHelper.trackEvent(CloudEvent.BatchClassify)
        dispatch({ type: "UPDATE_TRIP_BATCH_SUCCESS", trips })
        dispatch(getTotals())

        dispatch(untoggleAllTrips())

        const count = hasSelectedAll
          ? totalResultsCount
          : filter_params.token_ids.length

        dispatch({
          type: "SHOW_MODAL",
          modalType: "CLASSIFY_FILTERED_MODAL",
          modalProps: {
            buttonText: "Got it",
            title: `${count} Trips Updated`,
            message: `${count} trips have been successfully classified as ${purposeOption}`
          }
        })

        if (!hasSelectedAll) {
          dispatch(
            decrementUnclassfiedCount(prevState, filter_params.token_ids)
          )
        }

        if (hasSelectedAll) {
          if (data.filter_params.uncategorized)
            dispatch({
              type: "DECREMENT_UNCLASSIFIED_TRIP_COUNT",
              count: totalResultsCount
            })

          // setTimeout(()=>dispatch(clearFilters()), 3000)
        }

        trips.forEach(
          trip =>
            isNotMatchingFilters(filters, trip) &&
            dispatch({ type: "REMOVE_TRIP", trip })
        )

        // const filtersApplied = Object.keys(filters).length>0
        // if (filtersApplied) {
        //   // message.success(`${count} trips classified as ${purposeOption}`)
        //
        //   dispatch(getTrips())
        // }
      },
      err => dispatch({ type: "UPDATE_TRIP_BATCH_ERROR" })
    )
  }
}

export function untoggleAllTrips() {
  return dispatch => {
    dispatch({ type: "HIDE_CHECKBOXES" })
    dispatch({ type: "UNTOGGLE_ALL_TRIPS" })
    dispatch({ type: "UNSELECT_ALL_FILTERED_TRIPS" })
  }
}

export function toggleTrip(token_id) {
  return (dispatch, getState) => {
    dispatch({ type: "TOGGLE_TRIP", token_id })
    dispatch({ type: "SHOW_CHECKBOXES" })

    const {
      filter_params: { token_ids },
      hasSelectedAll
    } = getState().trips
    const { trips } = getState().models
    const areAllToggled = token_ids.length == trips.length
    // if (hasSelectedAll && !areAllToggled) dispatch({type: 'UNSELECT_ALL_FILTERED_TRIPS'})
    if (hasSelectedAll && !areAllToggled) dispatch(untoggleAllTrips())
  }
}

export function toggleManyTrips() {
  return (dispatch, getState) => {
    const { hasSelectedAll } = getState().trips
    const { trips } = getState().models

    if (hasSelectedAll) {
      const tokenIds = trips.map(trip => trip.token_id)
      dispatch({ type: "UNTOGGLE_ALL_TRIPS" })
      dispatch({ type: "SHOW_CHECKBOXES" })

      dispatch({ type: "TOGGLE_MANY_TRIPS", tokenIds })
    }
  }
}

export function hideCheckboxes() {
  return dispatch => {
    dispatch({ type: "HIDE_CHECKBOXES" })
  }
}

export function showCheckboxes() {
  return dispatch => {
    dispatch({ type: "SHOW_CHECKBOXES" })
  }
}

export function onOpenChange() {
  return dispatch => {
    dispatch({ type: "TOGGLE_RANGEPICKER" })
  }
}

export function clearFilters() {
  return dispatch => {
    dispatch({ type: "CLEAR_ALL_FILTERS" })
    dispatch({ type: "UNTOGGLE_ALL_TRIPS" })
    dispatch({ type: "HIDE_CHECKBOXES" })

    dispatch({ type: "UNSELECT_ALL_FILTERED_TRIPS" })
    dispatch(getTrips())
    dispatch(getTotals())
  }
}

export function updateNote(prevNotes, notes, token_id) {
  if (notes.trim().length > 0 && prevNotes != notes) console.log(notes)
  return dispatch => {}
}

export function updateRange(value) {
  return dispatch => {
    AnalyticsHelper.trackEvent(CloudEvent.FilterDates)

    dispatch({ type: "CLOSE_FILTER_POPOVER" })

    dispatch({ type: "APPLY_DATE_FILTER", dateRange: value })
    dispatch(getTrips())
    dispatch(getTotals())
  }
}

export function selectPlaceFilter(placeId) {
  return dispatch => {
    AnalyticsHelper.trackEvent(CloudEvent.FilterFavoritePlace)
    dispatch({ type: "SELECT_FAVE_PLACE_FILTER", placeId })
    dispatch(getTrips())
    dispatch(getTotals())
  }
}

export function selectFilter(filter) {
  return (dispatch, getState) => {
    AnalyticsHelper.trackEvent(CloudEvent.FilterBusinessLine)
    const { income_sources } = getState().models.user
    dispatch({ type: "SELECT_FILTER", filter, income_sources })
    dispatch(getTrips())
    dispatch(getTotals())
  }
}

export function selectVehicleFilter(vehicleId) {
  return dispatch => {
    AnalyticsHelper.trackEvent(CloudEvent.FilterVehicle)
    dispatch({ type: "SELECT_VEHICLE_FILTER", vehicleId })
    dispatch(getTrips())
    dispatch(getTotals())
  }
}

export function loadMore() {
  return (dispatch, getState) => {
    const { filters } = getState().trips

    const starting_after = getState().models.trips[
      getState().models.trips.length - 1
    ].token_id

    dispatch({ type: "GET_MORE_TRIPS_REQUEST" })

    return ApiHelper.getTrips({ starting_after, ...filters }).then(
      ({ data: trips }) => {
        if (trips.length == 0) return dispatch({ type: "NO_MORE_TRIPS" })
        // NOTE preload to check ahead of time instead of having user click
        // or ... check if json.data.length<10 ...

        if (trips.length < 10) {
          dispatch({ type: "GET_MORE_TRIPS_SUCCESS", user: { trips } })
          dispatch(toggleManyTrips())

          dispatch({ type: "NO_MORE_TRIPS" })
          return
        }
        // else
        dispatch({ type: "GET_MORE_TRIPS_SUCCESS", user: { trips } })
        dispatch(toggleManyTrips())
      }
    )
  }
}

export function createTrip(data) {
  return dispatch => {
    dispatch({ type: "CREATE_TRIP_REQUEST", trip: data })

    if (!data.locations)
      throw new SubmissionError({
        locations: "locations are empty",
        _error: "Please enter origin and destination."
      })

    return ApiHelper.createTrip(data).then(json => {
      dispatch(getTotals())
      AnalyticsHelper.trackEvent(CloudEvent.TripCreated)
      dispatch({
        type: "CREATE_TRIP_SUCCESS",
        trip: json.data,
        receivedAt: Date.now()
      })
      return json
    })
  }
}

export function getTotals() {
  return (dispatch, getState) => {
    const { filters } = getState().trips
    dispatch({ type: "GET_TOTALS_REQUEST", filters })
    return ApiHelper.getTotals(filters).then(json =>
      dispatch({ type: "GET_TOTALS_SUCCESS", user: { totals: json.data } })
    )
  }
}

export function selectAll() {
  return (dispatch, getState) => {
    // select all checkboxes visible

    dispatch({ type: "SELECT_ALL_FILTERED_TRIPS" })
    dispatch(toggleManyTrips())
  }
}



// WEBPACK FOOTER //
// ./src/trips/actions.js